import React, { Component } from 'react'
import Header from '../../components/Header'
import BarraLateral from '../../components/BarraLateral';
import './dashboard.css'
import Modal from 'react-modal'
import ModalFormDocumento from '../../components/Modais/ModalFormDocumento';
import ModalPDF from '../../components/Modais/ModalPDF'

import { connect } from 'react-redux';

import {
    listaDocumentos,
    addSigDoc
} from '../../actions'

class Dashboard extends Component{
    constructor() {
        super();
    
        this.state = {
            modalIsOpen: false,
            modalPDF: false,
            signatario: {
                tipoAss: 'Assinar',
                tipoAut: 'E-mail'
            },
            erro:false
        };
    
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.inputChange = this.inputChange.bind(this)
        this.formSubmit = this.formSubmit.bind(this)
    }

    inputChange(event){
        let signatario = this.state.signatario
        let name = event.target.name
        let value = event.target.value
        signatario[name] = value
        
        this.setState({signatario})
    }

    formSubmit(event){
        event.preventDefault()
        const { documento } = this.props.documentos

        if(documento == undefined) return alert('Adicione um documento antes de continuar!') 

        var { signatario } = this.state
        var { signatario } = this.state
        if( signatario.mensagem == undefined ) signatario.mensagem = ''

        

        this.props.addSigDoc(documento,signatario, (erro) => {
            this.setState({modalIsOpen: true,erro});
        })
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});

    }

    modalPDF() {
        this.setState({modalPDF: !this.state.modalPDF});
    }

    componentDidMount(){
        this.props.listaDocumentos()
    }

    
    render(){
        var { documento, sig_msg, sig_load} = this.props.documentos

        return(
            <div className="principal">
                <Header />
                <div className="row" style={{width:'100%',marginLeft:'auto',marginRight:'auto'}}>
                    <BarraLateral />
                    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4" style={customStyles.main}>
                        <div
                        className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2">Enviar documento para assinatura</h1>
                        <div className="btn-toolbar mb-2 mb-md-0">
                            <button type="button" className="btn btn-success" data-toggle="modal"
                            data-target="#modalConclusion" onClick={this.openModal}>Enviar</button>
                        </div>
                        </div>


                        {/* <!-- Visualiza Documento --> */}
                        <div className="align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h3>Documento</h3>
                        <a onClick={() => this.modalPDF()} name="modalPDF" data-toggle="modal" data-target="#modalSeeDoc">{documento ? documento.titulo : 'Nome do arquivo/documento enviado.pdf'}</a>

                        </div>

                        {/* <!-- Cadastro signatárioss --> */}
                        <div className="align-items-center pt-3 pb-2 mb-3 border-bottom">

                            <h3>Signatário</h3>
                            <form onSubmit={this.formSubmit}>

                                <div className="row">

                                    {/* <div className="col- align-self-center">

                                        <button type="button" className="btn-sm btn-danger">Apagar</button>
                                    </div> */}

                                    <div className="col">
                                        <label >E-mail do Signatário</label>

                                        <input name="email" type="email" className="form-control" placeholder="E-mail do Signatário" onChange={this.inputChange} required/>
                                    </div>

                                    <div className="col">
                                        <div className="form-group">
                                        <label>Autenticar como</label>
                                        <select name="tipoAut" className="form-control" id="exampleFormControlSelect1" onChange={this.inputChange} required>
                                            <option selected>E-mail</option>
                                            <option>SMS</option>
                                        </select>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <label>Celular</label>

                                        <input name="celular" type="tel" className="form-control" placeholder="Celular" onChange={this.inputChange} required/>
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col">
                                        <label >Nome Completo</label>

                                        <input name="nome" type="text" className="form-control" placeholder="Nome Completo" onChange={this.inputChange} required/>
                                    </div>

                                    <div className="col">
                                        <label >CPF</label>

                                        <input maxLength="11" name="cpfCnpj" type="text" className="form-control" placeholder="CPF" onChange={this.inputChange} required/>
                                    </div>

                                    <div className="col">
                                        <label >Data de nascimento</label>

                                        <input name="dataNasc" type="date" className="form-control" placeholder="Data de nascimento"onChange={this.inputChange} required/>
                                    </div>

                                    <div className="col">
                                        <div className="form-group">
                                        <label >Assinar como</label>
                                        <select name="tipoAss" className="form-control" id="exampleFormControlSelect1" onChange={this.inputChange} required>
                                            <option selected>Assinar</option>
                                            <option>Assinar como testemunha</option>
                                            <option>Assinar como parte</option>
                                            <option>Acusar recebimento</option>
                                            <option>Aprovar</option>
                                        </select>
                                        </div>
                                    </div>
                                </div>


                                {/* <button type="button" className="btn btn-primary mt-3 mb-3">+ Adicionar outro</button> */}

                            <div>
                                <h6>Mensagem para os signatários. (opicional)</h6>
                                <textarea name="mensagem" className="form-control" id="exampleFormControlTextarea1" rows="2" onChange={this.inputChange}></textarea>
                            </div>

                                <button type="button" className="btn btn-info mt-3 mb-3" style={{marginRight:'1%'}}>Visualizar Mensagem</button>

                                <button type="submit" name="modalIsOpen" className="btn btn-success" disabled={sig_load}>
                                    {sig_load ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : null}
                                    {sig_load ? 'Aguarde...' : 'Enviar'}
                                </button>
                            </form>

                        </div>
                    </main>
                </div>

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    style={customStyles.modal}
                    ariaHideApp={false}
                    >
                    
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel" >Conclusão</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                            </div>
                            <div className="modal-body text-center">
                            <img className="mb-4 " src={`/assets/imagem/${this.state.erro ? 'cancelado' : 'concluido'}.png`} alt="" width="100" height="100" />

                            <h4>{this.state.erro ? 'Erro ao enviar!' : 'Enviado com sucesso!'}</h4>
                            <small>{sig_msg}</small>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.closeModal}>Concluir</button>
                        </div>                 

                </Modal>

                {this.state.modalPDF
                    ?<ModalPDF closeModal={() => this.modalPDF()} />
                    :null
                }
                
                <style>
                {
                    `
                    .ReactModal__Content.ReactModal__Content--after-open{
                        width: 50%!important;
                        height: 65%!important;
                        top: 80px!important;
                        left: 34%!important;
                    }
                    `
                }
                </style>
            </div>
        )
    }
}

const mapStateToProps = ({ documentos, auth }) => {
    return {
        auth,
        documentos,
    }
}

export default connect(mapStateToProps, {
    listaDocumentos,
    addSigDoc
})(Dashboard);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        // height: '50%',
        left:'35%',
        top: '80px',
    }
}